import React from 'react';

const ClientAccountNumberBadge = ({ accountNumber, active }) => {
  return (
    <div className="inline-flex items-center gap-2 bg-blueWhisper px-3 py-1 rounded-full">
      <span className={`w-2 h-2 rounded-full ${active ? 'bg-tealMedium' : 'bg-bluePale'}`} />
      <span className="font-semibold text-blueMedium whitespace-nowrap" style={{ fontSize: '12px' }}>
        {accountNumber}
      </span>
    </div>
  );
};

export default ClientAccountNumberBadge;
